import { CURRENCY_DECIMALS, CurrencyEnum } from './enums/currency';

/**
 * The one money formatter. `locale` is the UI language's BCP-47 tag, `currency` the
 * restaurant's; `compact` is for chart axes and dense tiles ("₫1.3M", "$4.5K").
 */
export function formatMoney(
  amount: number | null | undefined,
  currency: CurrencyEnum,
  locale: string,
  options?: { compact?: boolean }
): string {
  if (amount == null) {
    return '';
  }
  const digits = CURRENCY_DECIMALS[currency];
  return new Intl.NumberFormat(
    locale,
    options?.compact
      ? { style: 'currency', currency, notation: 'compact', minimumFractionDigits: 0, maximumFractionDigits: 1 }
      : { style: 'currency', currency, minimumFractionDigits: digits, maximumFractionDigits: digits }
  ).format(amount);
}

/**
 * Rounds an amount to the currency's own decimals (0 for VND, 2 for USD), so summing float
 * subtotals never leaves cent-fraction noise ("13.33" + "13.33" + "13.34" = "39.99999999999999")
 * on the wire. A no-op for VND, which already has 0 decimals.
 */
export function roundMoney(amount: number, decimals: number): number {
  const scale = 10 ** decimals;
  return Math.round(amount * scale) / scale;
}
